<div class="pageheader">
  <div class="page-title">
    <h1>Compare Rules</h1>
    <div class="btn-group">
      <button class="btn btn-link" (click)="refresh()">Refresh <ep-svg-icon icon="repeat"></ep-svg-icon></button>
      <app-change-log-link *bizPermissionRequired="'Developer_Action_ShowLog'" [title]="'Compare Rules log'">
        <app-change-log-link-entity type="ComparePlugin"></app-change-log-link-entity>
      </app-change-log-link>
    </div>
  </div>
</div>

<label>
  <ep-svg-icon icon="info"></ep-svg-icon>
  Important: When comparing files the first record that matches the given arguments will be applied. Use the 'Edit order' function to make sure that the logical sequence is correct.
</label>

<div class="btn-toolbar">
  <div class="btn-group">
    <button class="btn btn-primary btn-sm" [disabled]="disableEditOrderButton()" (click)="onEditOrderClick()">Edit order</button>
  </div>
  @if (orderEditMode) {
    <div class="btn-group">
      <button class="btn btn-primary btn-sm" (click)="onSaveOrderClick()">Save order</button>
    </div>
  }
  @if (orderEditMode) {
    <div class="btn-group">
      <button class="btn btn-primary btn-sm" (click)="onCancelOrderEditClick()">Cancel</button>
    </div>
  }
  @if (!orderEditMode) {
    <div *bizPermissionRequired="'TestTool_Action_Compare_Rules_Export'" class="btn-group">
      <button class="btn btn-primary btn-sm" [disabled]="!canExportCompareRules" (click)="exportCompareRules()">Export</button>
    </div>
  }
</div>

<dx-data-grid #compareRulessGrid biz-grid [selection]='{ mode: "multiple" }' [dataSource]='compareRules' [bizHideSelectedRowsComponent]="true" [showResetButton]="true"
  (onInitNewRow)="onInitNewRow($event)" (onRowInserting)="onRowInserting($event)" (onRowUpdating)="onRowUpdating($event)" (onRowRemoving)="onRowRemoving($event)"
  (onRowValidating)="onRowValidating($event)" (onEditCanceled)="onEditCanceled($event)" (onEditingStart)="onEditingStart($event)" [bizEditRowOnDoubleClick]="true">

  <dxo-row-dragging [allowReordering]="orderEditMode" [onReorder]="onReorder" dropFeedbackMode="push" />

  <dxo-sorting mode="none" />

  <dxo-editing mode="popup" [allowAdding]="hasCompareRuleCreatePerm" [allowUpdating]="allowUpdatingRow" [allowDeleting]="allowDeletingRow">
    <dxo-form [customizeItem]="customizeItem"></dxo-form>
    <dxo-form>
      <dxi-item dataField="Name" [colSpan]="1"></dxi-item>
      <dxi-item dataField="Description" [colSpan]="1"></dxi-item>
      <dxi-item dataField="ArtifactId" [colSpan]="1" editCellTemplate="artifactEditTemplate"></dxi-item>
      <dxi-item dataField="FormatTypesId" [colSpan]="1" editCellTemplate="formatTypeDropDown"></dxi-item>
      <dxi-item dataField="DocumentTypesId" [colSpan]="2" editCellTemplate="docTypeDropDown"></dxi-item>
      <dxi-item dataField="DocumentConfigsId_In" [colSpan]="1" editCellTemplate="documentConfigEditor_In" [disabled]="selectedDocumentType < 1"></dxi-item>
      <dxi-item dataField="PartnersId_In" [colSpan]="1" editCellTemplate="partnerFromTemplate"></dxi-item>
      <dxi-item dataField="DocumentConfigsId_Out" [colSpan]="1" editCellTemplate="documentConfigEditor_Out" [disabled]="selectedDocumentType < 1"></dxi-item>
      <dxi-item dataField="PartnersId_Out" [colSpan]="1" editCellTemplate="partnerToTemplate"></dxi-item>
    </dxo-form>
  </dxo-editing>

  <dxo-column-fixing [enabled]="true"></dxo-column-fixing>
  <dxi-column dataField="Name" caption="Name" dataType="string" [allowGrouping]="false"><dxi-validation-rule type="required"></dxi-validation-rule></dxi-column>
  <dxi-column dataField="FormatTypesId" caption="Format type" editCellTemplate="formatTypeDropDown">
    <dxo-lookup [dataSource]="formatTypes" valueExpr="Id" displayExpr="Name"></dxo-lookup>
    <dxi-validation-rule type="required"></dxi-validation-rule>
  </dxi-column>
  <dxi-column dataField="DocumentTypesId" [setCellValue]="setDocTypeValue" [calculateSortValue]="getDocumentTypeName" caption="Document type" editCellTemplate="docTypeDropDown">
    <dxo-lookup [dataSource]="docTypes" valueExpr="Id" displayExpr="Name"></dxo-lookup>
  </dxi-column>
  <dxi-column dataField="DocumentConfigsId_In" caption="Document Config In" dataType="string" cellTemplate="documentConfigViewer_In"
  editCellTemplate="documentConfigEditor_In"></dxi-column>
  <dxi-column dataField="PartnersId_In" caption="From Partner" [customizeText]="displayExprPartner" editCellTemplate="partnerFromTemplate"></dxi-column>
  <dxi-column dataField="DocumentConfigsId_Out" caption="Document Config Out" dataType="string" cellTemplate="documentConfigViewer_Out"
  editCellTemplate="documentConfigEditor_Out"></dxi-column>
  <dxi-column dataField="PartnersId_Out" caption="To Partner" [customizeText]="displayExprPartner" editCellTemplate="partnerToTemplate"></dxi-column>
  <dxi-column dataField="Description" caption="Description" dataType="string" [allowGrouping]="false"><dxi-validation-rule type="required"></dxi-validation-rule></dxi-column>
  <dxi-column dataField="ArtifactId" caption="Artifact" dataType="string" editCellTemplate="artifactEditTemplate" [customizeText]="displayExprArtifact">
    <dxi-validation-rule type="required"></dxi-validation-rule>
  </dxi-column>

  <dxi-column biz-grid-user dataField="CreatedBy" caption="Created By" [visible]="false">
    <dxo-header-filter [dataSource]="bizGridFiltervalues.getUserFilterData(bizGridFiltervalues.getPropertyValues(compareRules, 'CreatedBy'))"></dxo-header-filter>
  </dxi-column>
  <dxi-column biz-grid-date dataField="CreatedDate" caption="Created Date" [visible]="false" format="dateTime"></dxi-column>
  <dxi-column biz-grid-user dataField="UpdatedBy" caption="Modified By" [visible]="true">
    <dxo-header-filter [dataSource]="bizGridFiltervalues.getUserFilterData(bizGridFiltervalues.getPropertyValues(compareRules, 'UpdatedBy'))"></dxo-header-filter>
  </dxi-column>
  <dxi-column biz-grid-date dataField="UpdatedDate" caption="Modified Date" [visible]="true" format="dateTime"></dxi-column>

  <dxi-column type="buttons">
    <dxi-button name="edit"></dxi-button>
    <dxi-button name="delete"></dxi-button>
    <dxi-button name="clone" text="Copy" [onClick]="cloneCompare" [visible]="hasCompareRuleCreatePerm"></dxi-button>
    <dxi-button text="Show Log" template="logTemplate" [visible]="allowShowLog">
    </dxi-button>
  </dxi-column>

  <ng-container *dxTemplate="let cell of 'logTemplate'">
    <app-change-log-link *bizPermissionRequired="'Developer_Action_ShowLog'" [title]="'Log for ' + cell.data.Name" [showIcon]="false" classNames="dx-link">
      <app-change-log-link-entity type="ComparePlugin" [id]="cell.data.Id"></app-change-log-link-entity>
    </app-change-log-link>
  </ng-container>

  <ng-container *dxTemplate="let cellInfo of 'artifactEditTemplate'">
    <app-developer-artifact-assembly-picker [assemblyTypes]="['ComparePlugin']" (selectedArtifactIdChange)="setArtifactId($event, cellInfo)"
    [selectedArtifactId]="cellInfo.data.ArtifactId"></app-developer-artifact-assembly-picker>
    @if (compareRuleDisplayGroups.length > 0) {
      <ep-datafield-group-container [formValidationGroup]="compareRuleFormGroup" [showError]="true"
      [datafieldGroups]="compareRuleDisplayGroups" [isAlwaysEditable]="true" [numberOfColumns]="2"></ep-datafield-group-container>
    }
  </ng-container>

  <div *dxTemplate="let cellinfo of 'partnerToTemplate'">
    <ep-partner-selector id="toPartnerID" #partnerSelectorTo [selectedPartner]="getPartner(cellinfo)" (selectedPartnerChange)="setPartnerToId($event, cellinfo)"
    [isReadOnly]="false"></ep-partner-selector>
  </div>
  <div *dxTemplate="let cellinfo of 'partnerFromTemplate'">
    <ep-partner-selector id="fromPartnerID" #partnerSelectorFrom [selectedPartner]="getPartner(cellinfo)" (selectedPartnerChange)="setPartnerFromId($event, cellinfo)"
    [isReadOnly]="false"></ep-partner-selector>
  </div>

  <div *dxTemplate="let cellInfo of 'documentConfigEditor_In'">
    <select class="form-control" [ngModel]="selectedDocumentConfig_In" (ngModelChange)="onDocConfigInValueChanged($event, cellInfo)">
      <option [ngValue]="null">{{documentConfigsToDisplay_In.length > 0 ? "Select..." : "No document configs for the currently selected document type..."}}</option>
      @for (item of documentConfigsToDisplay_In; track item) {
        <option [ngValue]="item.DocumentConfigId" [title]="item.Description">
          {{item.FormatName}} / {{item.VariantName}} / {{item.VersionName}}
        </option>
      }
    </select>
  </div>

  <div *dxTemplate="let cellInfo of 'documentConfigViewer_In'">
    <span>{{getDocumentConfigName_In(cellInfo.data)}}</span>
  </div>

  <div *dxTemplate="let cellInfo of 'documentConfigEditor_Out'">
    <select class="form-control" [ngModel]="selectedDocumentConfig_Out" (ngModelChange)="onDocConfigOutValueChanged($event, cellInfo)">
      <option [ngValue]="null">{{documentConfigsToDisplay_Out.length > 0 ? "Select..." : "No document configs for the currently selected document type and format type..."}}</option>
      @for (item of documentConfigsToDisplay_Out; track item) {
        <option [ngValue]="item.DocumentConfigId" [title]="item.Description">
          {{item.FormatName}} / {{item.VariantName}} / {{item.VersionName}}
        </option>
      }
    </select>
  </div>

  <div *dxTemplate="let cellInfo of 'documentConfigViewer_Out'">
    <span>{{getDocumentConfigName_Out(cellInfo.data)}}</span>
  </div>

  <div *dxTemplate="let cellInfo of 'formatTypeDropDown'">
    <dx-drop-down-box [dropDownOptions]="dropDownOptions" [dataSource]="formatTypes" [(value)]="cellInfo.value" displayExpr="Name" valueExpr="Id" contentTemplate="contentTemplate">
      <div *dxTemplate="let e of 'contentTemplate'">
        <dx-data-grid [dataSource]="formatTypes" [remoteOperations]="true" [height]="250" [selectedRowKeys]="[cellInfo.value]" [focusedRowEnabled]="true"
          [focusedRowKey]="cellInfo.value" [hoverStateEnabled]="true" keyExpr="Id"
          (onSelectionChanged)="onFormatTypeSelectionChanged($event.selectedRowKeys, cellInfo, e.component)">
          <dxi-column caption="Name" dataField="Name" sortOrder="asc"></dxi-column>
          <dxi-column caption="Default ext." dataField="DefaultExtension"></dxi-column>
          <dxo-paging [enabled]="true" [pageSize]="10"></dxo-paging>
          <dxo-scrolling mode="virtual"></dxo-scrolling>
          <dxo-selection mode="single"></dxo-selection>
        </dx-data-grid>
      </div>
    </dx-drop-down-box>
  </div>

  <div *dxTemplate="let cellInfo of 'docTypeDropDown'">
    <dx-drop-down-box [dropDownOptions]="dropDownOptions" [dataSource]="docTypes" [(value)]="cellInfo.value" displayExpr="Name" valueExpr="Id" contentTemplate="contentTemplate">
      <div *dxTemplate="let e of 'contentTemplate'">
        <dx-data-grid [dataSource]="docTypes" [remoteOperations]="true" [height]="250" [selectedRowKeys]="[cellInfo.value]" [focusedRowEnabled]="true"
          [focusedRowKey]="cellInfo.value" [hoverStateEnabled]="true" keyExpr="Id"
          (onSelectionChanged)="onDocTypeSelectionChanged($event.selectedRowKeys, cellInfo, e.component)">
          <dxi-column dataField="Name" [sortingMethod]="sortWithAllItem" sortOrder="asc"></dxi-column>
          <dxi-column dataField="Description"></dxi-column>
          <dxo-paging [enabled]="true" [pageSize]="10"></dxo-paging>
          <dxo-scrolling mode="virtual"></dxo-scrolling>
          <dxo-selection mode="single"></dxo-selection>
        </dx-data-grid>
      </div>
    </dx-drop-down-box>
  </div>

</dx-data-grid>
